import React from 'react';
import { InvitationType } from '../../_graphql/generated/operations';

interface InvitationTypeListStandaloneProps {
  invitationTypes: InvitationType[];
  onTypeSelect?: (invitationType: InvitationType) => void;
  selectedTypeId?: string;
}

const InvitationTypeListStandalone: React.FC<InvitationTypeListStandaloneProps> = ({ 
  invitationTypes, 
  onTypeSelect, 
  selectedTypeId 
}) => {
  const handleTypeClick = (invitationType: InvitationType) => {
    if (onTypeSelect) {
      onTypeSelect(invitationType);
    }
  };

  return (
    <div>
      {invitationTypes.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-500 text-sm">No invitation types available</p>
        </div>
      ) : (
        <div className="space-y-3">
          {invitationTypes.map((invitationType) => (
            <div
              key={invitationType.id}
              className={`p-4 border rounded-lg transition-colors cursor-pointer ${
                selectedTypeId === invitationType.id 
                  ? 'border-green-500 bg-green-50' 
                  : 'border-gray-200 hover:border-gray-300'
              }`}
              onClick={() => handleTypeClick(invitationType)}
            >
              <div className="flex-1">
                <h4 className="font-medium text-gray-800">{invitationType.name}</h4>
                {invitationType.description && (
                  <p className="text-sm text-gray-600 mt-1">{invitationType.description}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InvitationTypeListStandalone;